import { render, staticRenderFns } from "./shipping-dialog.vue?vue&type=template&id=5a9e6ed2&"
import script from "./shipping-dialog.vue?vue&type=script&lang=js&"
export * from "./shipping-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports